import { Link2 } from "lucide-react";

export default function BillingQuestions() {
    return (
        <>
            For questions about billing,{" "}
            <a className="hover:bg-neutral-200/70 py-0.5 px-1 -ml-0.5 rounded-sm" href="mailto:support@orsane.com">
                contact us
                <Link2 className="size-3.5 inline-block ml-1" />
            </a>
            .
        </>
    );
}
